import $axios from '../services/apiLms.js'

const state = () => ({
    total_unread: 0,
    surat_masuk: [],
    disposisi: [],
    tembusan: [],
    is_installed : true,
});

const mutations = {
    ASSIGN_TOTAL_UNREAD(state, payload) {
        state.total_unread = payload;
    },
    ASSIGN_SURAT_MASUK(state, payload) {
        state.surat_masuk = payload
    },
    ASSIGN_DISPOSISI(state, payload) {
        state.disposisi = payload
    },
    ASSIGN_TEMBUSAN(state, payload) {
        state.tembusan = payload
    },
    ASSIGN_INSTALLED(state, payload) {
        state.is_installed = payload
    }
};

const actions = {
    getSuratMasuk({ commit }, payload) {
        return new Promise((resolve, reject) => {
            $axios.get(`kepsek/surat-masuk`, {
                params: {
                    id: payload.id || "",
                    unread: payload.unread || false
                }
            })
                .then(({ data }) => {
                    commit('ASSIGN_SURAT_MASUK', data.data);
                    resolve(data);
                }, () => {
                    commit('ASSIGN_SURAT_MASUK', 0);
                    commit('ASSIGN_INSTALLED', false);
                    reject(null);
                })
        });
    },
    getDisposisi({ commit }, payload) {
        return new Promise((resolve) => {
            $axios.get(`kepsek/disposisi`, {
                params: {
                    id_sm: payload.id_sm || "",
                    id_memo: payload.id_memo || "",
                    unread: payload.unread || false
                }
            })
                .then(({ data }) => {
                    commit('ASSIGN_DISPOSISI', data.data);
                    resolve(data);
                })
        });
    },
    readSurat({ commit }, payload) {
        return new Promise((resolve) => {
            $axios.post(`kepsek/read-surat`, {
                id_sm: payload.id_sm,
                kode: payload.kode
            })
                .then(({ data }) => {
                    resolve(data);
                })
        });
    },
    getTembusan({ commit }, payload) {
        return new Promise((resolve) => {
            $axios.get(`kepsek/tembusan`, {
                params: {
                    id_sm: payload.id_sm || "",
                    id_memo: payload.id_memo || "",
                    id_tembusan: payload.id_tembusan || "",
                    unread: payload.unread || false
                }
            })
                .then(({ data }) => {
                    commit('ASSIGN_TEMBUSAN', data.data);
                    resolve(data);
                })
        });
    },
    getSuratTotalUnread({ commit, dispatch }) {
        let total_unread = 0;
        return new Promise((resolve, reject) => {
            dispatch("getSuratMasuk", {
                unread: true
            })
                .then(({ data }) => {
                    total_unread += data.length;
                    dispatch("getDisposisi", {
                        unread: true
                    })
                        .then(({ data }) => {
                            total_unread += data.length;
                            dispatch("getTembusan", {
                                unread: true
                            })
                                .then(({ data }) => {
                                    total_unread += data.length;
                                    commit("ASSIGN_TOTAL_UNREAD", total_unread);
                                    resolve(total_unread)
                                })
                        });
                }, () => {
                    commit("ASSIGN_TOTAL_UNREAD", 0);
                    resolve(0)
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
